import {otpReqPending, otpReqSuccess, otpReqFail, updatePassSuccess,updatePassPending,updatePassFail} from "./passwordSlice";
import { reqPasswordOtp, updateUserPassword } from "../../api/paaswordApi";

export const sendPasswordResetOtp = email => async dispatch => {
    try {
      dispatch(otpReqPending());
  
      const result = await reqPasswordOtp(email);
      console.log(result);
  
      if (result.status === "success") {
        return dispatch(otpReqSuccess(result)); 
      }
  
      dispatch(otpReqFail());
    } catch (error) {
      dispatch(otpReqFail());
    }
  };
  

export const updatePassword= frmData => async dispatch => {
    try{
        dispatch(updatePassPending());


        const result = await updateUserPassword(frmData);
        console.log(result);

        if(result.status === "success")
        {
            return dispatch(updatePassSuccess(result));
        }
        dispatch(updatePassFail(result));
    }catch(error){
        dispatch(updatePassFail(error));
    }
}